import { CrossCircledIcon } from "@radix-ui/react-icons";
import { Flex } from "@radix-ui/themes";
import PropTypes from "prop-types";

Error.propTypes = {
  children: PropTypes.node,
};

export default function Error({ children }) {
  return (
    <Flex gap="3" align="center" color="red">
      <CrossCircledIcon color="red" />
      {children}
    </Flex>
  );
}
